import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const restoreQnsAction = createAsyncThunk(
    'restore-qns-ans',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/admins/api/restore-question-answer/${data}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const restoreQnsSlice = createSlice({
    name: 'restore-qns-ans',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(restoreQnsAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(restoreQnsAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(restoreQnsAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const restoreQnsReducer = restoreQnsSlice.reducer    